import { Button, MenuItem, TextField, Typography, useTheme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import React, { useEffect, useState, useMemo } from 'react'
// import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { purple } from '../../utils/colors'
import { getBasicMembershipInfo } from '../../utils'

const useStyles = makeStyles(() => ({
	dialog: {
		'& .MuiDialog-paper': {
			width: 920,
			maxWidth: 1000
		}
	},
	header: {
		marginBottom: 12,
		fontSize: 16,
		fontWeight: '800',
		textTransform: 'capitalize',
		marginBottom: 16,
		marginRight: 12,
		marginTop: 16
	},
	accessMethodContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		width: '58%',
		alignItems: 'center'
	},
	accessMethodText: {
		fontSize: 16,
		fontWeight: '600',
		textTransform: 'capitalize',
		marginBottom: 16,
		marginRight: 12
	},
	accessMethodText2: {
		fontSize: 16,
		fontWeight: '600',
		marginBottom: 16,
		marginRight: 12
	},
	upgradeButton: {
		color: purple[500],
		paddingLeft: 0,
		marginBottom: 10,
		fontSize: 14,
		fontWeight: '800'
	}
}))

const DAY_FORMAT = moment().format('dddd')

export const AccessMethod = ({
	checkIn,
	setEntry,
	entry,
	facility,
	isVipTrial,
	needsPass,
	hasDayPass,
	guestDogs,
	validMemberships,
	numDogs,
	shouldChargeForFirstCheckIn
}) => {
	const classes = useStyles()
	// const history = useHistory()
	let [dayPassText, setDayPassText] = useState('')

	// console.info({ checkIn })

	useEffect(() => {
		if (checkIn) {
			if (checkIn.day_passes && checkIn.day_passes[0]) {
				setDayPassText(
					`Day Pass (${checkIn.day_passes[0].number} dog${checkIn.day_passes[0].number > 1 ? 's' : ''})`
				)
			}
			if (checkIn.daypass_id) {
				setDayPassText(
					`Day Pass${checkIn.pets?.length
						? ` (${checkIn.pets.length} dog${checkIn.pets.length > 1 ? 's' : ''})`
						: ''
					}`
				)
			}
		}
	}, [checkIn])

	const day_pass_price = facility.daypass_prices[DAY_FORMAT].day_pass_price
	const additional_pet_price = facility.daypass_prices[DAY_FORMAT].additional_pet_price

	let dayPass = {
		type: 'day_pass',
		name: 'Day Pass',
		price: day_pass_price,
		additional_pet_fee: additional_pet_price
	}

	const types = [dayPass]

	const navigateToSocialAccess = () => {
		const accounts = (checkIn?.accounts || []).filter((account) =>
			!checkIn.checked_in ? true : checkIn.checked_in_accounts.includes(account._id)
		)
		if (!accounts?.length) return

		const primary = accounts.find((a) => a.primary)
		const selected = primary || accounts[0]

		// history.push(`/clients/${selected.household}/membership`)
		const win = window.open(`/clients/${selected.household}/membership`)
		win.focus()
	}

	const accessMethodText = useMemo(() => {
		let method = 'UNKNOWN'
		if (checkIn) {
			method = getBasicMembershipInfo().name

			const [membership] = validMemberships

			if (hasDayPass) {
				method = dayPassText
			}

			if (membership) {
				method = membership.name || membership.type.replaceAll('_', ' ')
			}

			if (numDogs === 0) {
				method = `${method} - Human Only`
				return method
			}

			if (membership) {

				if (membership.grandfathered_pricing) {
					method = `${method} - Unlimited Dogs`
				} else {

					const numPets = parseInt(membership.number_of_pets, 10)
					method = `${method} - ${numPets} dog${numPets > 1 ? 's' : ''}`
				}
			}
		}
		return method
	}, [checkIn, dayPassText, validMemberships, hasDayPass, numDogs])

	return (
		<div>
			<div>
				<Typography className={classes.header}>Access Method</Typography>
			</div>
			<div className={classes.accessMethodContainer} style={{ position: 'relative' }}>
				<div className={classes.headThing}>
					<Typography className={classes.accessMethodText}>{accessMethodText}</Typography>
					{guestDogs?.length ? (<Typography className={classes.accessMethodText2}>Guest Pass - {guestDogs.length} Dog(s)</Typography>) : null}
				</div>
				{!isVipTrial && (
					<Button
						variant="text"
						disabled={false}
						onClick={navigateToSocialAccess}
						style={{ position: 'absolute', top: -5, right: 10}}
						endIcon={
							<i
								className="far fa-window-restore"
								style={{ color: purple[500], marginLeft: '8px' }}
							/>
						}
						className={classes.upgradeButton}>
						UPGRADE MEMBERSHIP
					</Button>
				)}
			</div>
			{!isVipTrial && needsPass && numDogs > 0 && (
				<div>
					<TextField
						variant="filled"
						select
						disabled={false}
						value={entry.access_type || ''}
						label="Access Type"
						style={{ marginBottom: 16, minWidth: 240, marginRight: 16 }}
						InputProps={{
							style: {
								width: '50%',
								minWidth: 240
							}
						}}
						onChange={(e) => {
							setEntry({ ...entry, access_type: e.target.value })
						}}>
						{types.map((option) => (
							<MenuItem
								key={option.type}
								value={option.type}
								style={{ textTransform: 'capitalize' }}>
								{option.name} {option.billing_method || ''}
							</MenuItem>
						))}
					</TextField>
					<TextField
						variant="filled"
						disabled={false}
						select
						value={entry.number || ''}
						style={{ marginBottom: 16, minWidth: 240 }}
						InputProps={{
							style: {
								width: '50%',
								minWidth: 240
							}
						}}
						label="Number of Dogs"
						onChange={(e) => setEntry({ ...entry, number: e.target.value })}>
						{[1, 2, 3, 4].map((option) => (
							<MenuItem key={option} value={option}>
								{option}
							</MenuItem>
						))}
					</TextField>
				</div>
			)}
		</div>
	)
}
